import React, { useEffect, useRef } from 'react';
import { useCalculationContext } from '../../../components/CalculationProvider';
import { useDataSource } from '@afosto/app-components-react/DataSource';
import ItemsList from '../../../components/ItemsList';
import ProjectionList from '../../../components/ProjectionList';
import dataSourceRequest from '@afosto/utils-react/dataSource/dataSourceRequest';
import fetchMultipleProducts from '@afosto/utils-react/fetchMultipleProducts';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';
import formatAdjustments from '../../../utils/formatAdjustments';

const CalculationItems = () => {
  const { calculation } = useCalculationContext();

  const fetchCalculationItems = async dataSource =>
    dataSourceRequest(dataSource, async () => ({ data: calculation?.items ?? [] }), {
      transformData: async (data, source) => {
        try {
          const { activePage, itemsPerPage, setItemCount } = source?.pagination ?? {};
          const items = (data ?? []).slice(
            activePage * itemsPerPage,
            (activePage + 1) * itemsPerPage,
          );
          const products = await fetchMultipleProducts(
            items.map(item => item.sku),
            {},
            {
              headers: {
                'x-page-size': itemsPerPage,
              },
            },
          );

          setItemCount(data?.length);

          return items.reduce((acc, item) => {
            const product = findObjectInArray(products, 'sku', item.sku);
            return [
              ...acc,
              {
                ...item,
                adjustments: formatAdjustments(item?.adjustments),
                image: product?.image,
              },
            ];
          }, []);
        } catch (err) {
          return [];
        }
      },
    });

  const dataSource = useDataSource(fetchCalculationItems, {
    modules: ['pagination'],
    pagination: {
      itemsPerPage: 100,
    },
  });
  const dataSourceRef = useRef(dataSource);

  useEffect(() => {
    dataSourceRef.current = dataSource;
  });

  useEffect(() => {
    if (calculation) {
      dataSourceRef.current.reloadDataSource();
    }
  }, [calculation]);

  return (
    <>
      <ItemsList
        dataSource={dataSource}
        isVatShifted={calculation?.is_vat_shifted}
        isIncludingVat={calculation?.is_including_vat}
      />
      <div style={{ padding: 16 }}>
        <ProjectionList projection={calculation} />
      </div>
    </>
  );
};

export default CalculationItems;
